import { Http } from '../../../support';

const initialState = {
  isValid: false,
  busy: false,
  fetching: false,
  tenancy: null,
  data: {},
  steps: {
    csd: false,
    manifiesto: false,
  },
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.emisores.upsert = {
      ...state.app.emisores.upsert,
      ...data,
    };
  });
};

const isValid = (steps) => {
  let valid = true;

  for (const step of Object.values(steps)) {
    if (step !== true) {
      valid = false;

      break;
    }
  }

  return valid;
};

const setStepDataChange = (store, event, callback) => {
  const { upsert } = store.state.app.emisores;

  const steps = event.steps || upsert.steps;

  store.setState((state) => {
    state.app.emisores.upsert = {
      ...state.app.emisores.upsert,
      data: { ...event.data },
      steps: steps,
      isValid: isValid(steps),
    };
  }, callback);
};

const upsert = async (store, data, id, options = {}) => {
  store.setState((state) => {
    state.app.emisores.upsert.busy = true;
  });

  try {
    const { tenancy = undefined } = store.state.app.emisores.upsert;

    const headers = {
      'X-Tenancy': tenancy || undefined,
    };

    const params = {
      include: 'series,nomina',
    };

    let response = null;

    if (!id) {
      response = await Http.post(`api/emisores`, data, { headers, params });
    } else {
      response = await Http.put(`api/emisores/${id}`, data, { headers, params });
    }

    store.setState((state) => {
      state.app.emisores.upsert = {
        ...state.app.emisores.upsert,
        busy: false,
        result: response,
        data: {
          ...state.app.emisores.upsert.data,
          ...response.data,
          series: response.data.series || [],
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.emisores.upsert.busy = false;
      state.app.emisores.upsert.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.emisores.upsert = { ...initialState };
  });
};

const EmisorUpsertStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    setStepDataChange,
    upsert,
    reset,
  },
};

export default EmisorUpsertStore;
